import { render, staticRenderFns } from "./ViSchoolOverview.vue?vue&type=template&id=4810ea21&scoped=true"
import script from "./ViSchoolOverview.vue?vue&type=script&lang=js"
export * from "./ViSchoolOverview.vue?vue&type=script&lang=js"
import style0 from "./ViSchoolOverview.vue?vue&type=style&index=0&id=4810ea21&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4810ea21",
  null
  
)

export default component.exports